import React from "react";
import MainPageLayout from "../layouts/MainPageLayout.js";
const Homepage = ({ page }) => {

  
  return (
    <>
      <MainPageLayout page={page} pageEndpoint={`pages?filters[slug][$eq]=${page}`} />
    </>
  );
};

export default Homepage;
